import * as requestFromServer from "./organizationRegionalCrud";
import {
  superAdminOrganizationRegionalSlice,
  callTypes
} from "./organizationRegionalSlice";
import { actions as auth } from "../../../Auth/_redux/authRedux";
import { toastOption } from "../../../../../_metronic/_helpers/ToastHelpers";
import { toast } from "react-toastify";

const { actions } = superAdminOrganizationRegionalSlice;

export const fetchOrganizationRegionals = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findOrganizationRegional(queryParams)
    .then(response => {
      const {
        data: { total_items, items }
      } = response.data;
      dispatch(actions.organizationRegionalsFetched({ total_items, items }));
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchOrganizationRegionalById = id => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findOrganizationRegionalById(id)
    .then(response => {
      const { data } = response.data;
      dispatch(actions.organizationRegionalFetched({ data }));
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const createOrganizationRegional = payload => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createOrganizationRegional(payload)
    .then(response => {
      dispatch(actions.organizationRegionalReload);
      return response;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      return error.response.data;
    });
};

export const updateOrganizationRegional = payload => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateOrganizationRegional(payload)
    .then(response => {
      dispatch(actions.organizationRegionalReload);
      return response;
    })
    .catch(error => {
      if (error.response.status === 401) {
        toast.error(error.response.data.message, toastOption);
        dispatch(auth.logout());
      }
      error = error.response.data.message;
      dispatch(actions.catchError({ error, callType: callTypes.list }));
      return error.response.data;
    });
};

// export const deleteOrganizationRegionalFolder = id => dispatch => {
//   dispatch(actions.startCall({ callType: callTypes.action }));
//   return requestFromServer
//     .deleteOrganizationRegionalFolder(id)
//     .then(response => {
//       dispatch(actions.organizationRegionalReload);
//       return response;
//     })
//     .catch(error => {
//       if (error.response.status === 401) {
//         toast.error(error.response.data.message, toastOption);
//         dispatch(auth.logout());
//       }
//       // dispatch(actions.catchError({ error, callType: callTypes.list }));
//       dispatch(actions.catchError());
//       return error.response;
//     });
// };
